import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
import {
    normalizeTeamApiError,
    normalizeTeamApiResponse,
} from "./normalizeTeamApiResult";

export const updateTeam = async (team, teamId) => {
    try {
        const token = Cookies.get("Bearer");
        const response = await axios.put(
            `${FIRMFLOWURL}api/Team/${teamId}`,
            {
                ...team,
            },
            {
                headers: { Authorization: token },
            }
        );

        return normalizeTeamApiResponse(response, "Unable to update team.");
    } catch (err) {
        console.log(err);
        if (err?.response?.status === 401 || err?.message?.includes("401")) {
            Cookies.remove("Bearer");
            window.location.replace("/");
            return;
        }

        return normalizeTeamApiError(err, "Unable to update team.");
    }
};
